export default __webpack_public_path__ + "static/media/eye-off.debfee01.svg";